import React, { useEffect, useMemo } from 'react';
import { createPortal } from 'react-dom';
import { CSSTransition } from 'react-transition-group';
import classNames from 'classnames/bind';

import styles from './AsideModal.styl';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { getRewards } from '../../state/modules/stock/selectors';

const cx = classNames.bind(styles);

const portalRoot = typeof document !== 'undefined'
  ? (document.getElementById('portal-root') || document.body)
  : null;

export default function AsideModal({ open, onClose, children }) {
  const intl = useIntl();
  const composition = useSelector(state => state.cart.composition);
  const rewards = useSelector(getRewards);
  const rewardsCount = rewards?.length || 0;

  const asideOffsetPx = useMemo(() => 40 + rewardsCount * 38, [rewardsCount]);

  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  useEffect(() => {
    if (!composition.length) {
      onClose();
    }
  }, [composition, onClose]);

  if (!portalRoot) return null;

  return createPortal(
    <div
      className={cx('drawerOverlay', { drawerOverlay_open: open })}
      onClick={onClose}
      aria-hidden={!open}
      style={{ '--aside-offset': `${asideOffsetPx}px` }}
    >
      <CSSTransition
        in={open}
        timeout={300}
        unmountOnExit
        classNames={{
          enter: styles.drawerEnter,
          enterActive: styles.drawerEnterActive,
          exit: styles.drawerExit,
          exitActive: styles.drawerExitActive,
        }}
      >
        <aside
          className={cx('drawerPanel')}
          role="dialog"
          aria-modal="true"
          onClick={(e) => e.stopPropagation()}
        >
          <div className={cx('drawerHeader')}>
            <button className={cx('drawerBack')} onClick={onClose}>
              ← {intl.formatMessage({ id: 'button.back' })}
            </button>
          </div>

          <div className={cx('drawerContent')}>
            {children}
          </div>
        </aside>
      </CSSTransition>
    </div>,
    portalRoot,
  );
}
